import { motion } from "framer-motion";
import { team } from "@/data/content";

export default function Team() {
  return (
    <section id="chi-siamo" data-testid="team-section" className="bg-ink text-white py-24 lg:py-36 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full bg-azure/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="eyebrow text-azure mb-6"
        >
          Chi siamo
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl leading-[1.12] mb-16"
        >
          Persone vere, <span className="italic text-azure">non un algoritmo</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {team.map((m, i) => (
            <motion.article
              key={m.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              data-testid={`team-card-${i}`}
              className="rounded-3xl border border-white/10 bg-white/[0.04] overflow-hidden grid grid-cols-1 sm:grid-cols-5"
            >
              <div className="sm:col-span-2 h-64 sm:h-auto overflow-hidden">
                <img src={m.img} alt={m.name} loading="lazy" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-[filter] duration-700" />
              </div>
              <div className="sm:col-span-3 p-7 lg:p-8">
                <p className="font-serif italic text-gold text-lg">"{m.quote}"</p>
                <h3 className="mt-4 font-serif font-bold text-2xl">{m.name}</h3>
                <p className="text-xs uppercase tracking-[0.18em] text-azure font-semibold mt-1">{m.role}</p>
                <p className="mt-4 text-sm text-white/60 leading-relaxed">{m.bio}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
